import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

declare var bootstrap: any;

@Component({
    selector: 'app-aboutus',
    templateUrl: './aboutus.component.html',
    styleUrls: ['./aboutus.component.scss']
})
export class AboutusComponent implements OnInit {


    constructor(
        private meta: Meta,
        private titles: Title
    ) {
    }

    ngAfterViewInit(): void {
        const carouselElement = document.getElementById('carouselExampleIndicators');
        if (carouselElement) {
            const carousel = new bootstrap.Carousel(carouselElement, {
                interval: 5000, // Set the autoplay interval
                ride: 'carousel' // Enable autoplay
            });
        }
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Know About ARNI: Redefining Education and Innovation');
        this.meta.updateTag({
            name: 'description',
            content: `Learn about ARNI's journey of empowering minds with advanced education,
             research, and innovation. Building brighter futures with a passion for excellence.`
        });
    }

}
